import { motion } from "framer-motion";
import { MapPin, Quote, Star } from "lucide-react";
import { REVIEWS } from "../../data/site";
import Reveal, { ChapterTag } from "./Reveal";

export default function Testimonials() {
  return (
    <section id="reviews" data-testid="reviews-section" className="scroll-mt-24 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <ChapterTag index="05" label="Reviews" />
          <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
            <h2 className="max-w-2xl font-display text-4xl font-bold tracking-tight text-ink sm:text-5xl">
              1,000+ clients. <span className="text-mint-dark">Same answer every time.</span>
            </h2>
            <div className="flex items-center gap-2" data-testid="reviews-aggregate">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-tangy text-tangy" />
                ))}
              </div>
              <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-steel">
                4.9 / 5 · Rated by 1,000+ clients
              </span>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
          {REVIEWS.map((review, i) => (
            <motion.figure
              key={review.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1], delay: (i % 2) * 0.12 }}
              data-testid={`review-card-${i}`}
              className="flex flex-col rounded-3xl border border-line/80 bg-white p-8 shadow-sm transition-[box-shadow,transform] duration-300 sm:hover:-translate-y-1 sm:hover:shadow-xl"
            >
              <div className="flex items-center justify-between">
                <div className="flex">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-tangy text-tangy" />
                  ))}
                </div>
                <Quote className="h-6 w-6 text-line" />
              </div>
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-steel">
                "{review.text}"
              </blockquote>
              <figcaption className="mt-6 flex flex-col items-start gap-1.5 border-t border-line pt-5 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
                <span className="font-display text-base font-bold text-ink">{review.name}</span>
                <span className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.16em] text-steel">
                  <MapPin className="h-3.5 w-3.5 text-mint-dark" />
                  {review.area}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
